import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { FormikProps } from "formik";
import CustomTextArea from "../../../../../../../../../../../../components/CustomTextArea";
import Flex from "../../../../../../../../../../../../components/Flex";
import Text from "../../../../../../../../../../../../components/Text";
import StyledFormModal from "../../../../../../../../../../../../components/globalModal/StyledModal";
import StyledButtonV2 from "../../../../../../../../../../../../components/app/StyledButtonV2";
import { DisclosureHost } from "../../../../../../../../../../../../hooks/use-disclosure";
import useFormDraft from "../../../../../../../../../../../../hooks/use-form-draft";
import { Form2Payload } from "../../../../../../../../../scheduling/appointment/encounter/encounter-constant";
import { RISK_LEVEL_OPTIONS } from "../InitialPsychotherapyConstant";

interface RiskAssessmentProps {
  disclosureHost: DisclosureHost;
  formik: FormikProps<Form2Payload>;
}

const RISK_ASSESSMENT_FIELDS = ["riskLevel", "riskLevelNote"];

const RiskAssessmentModal = ({
  disclosureHost,
  formik,
}: RiskAssessmentProps) => {
  // Edits stay in the draft until Save, so the note behind the modal is
  // untouched while the user is still filling it in (ECRH-5663).
  const draft = useFormDraft(
    formik,
    RISK_ASSESSMENT_FIELDS,
    disclosureHost.opened
  );
  const riskLevel = draft.values.riskLevel ?? "";

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={() => disclosureHost.close()}
      dialogTitle="Risk Assessment"
      dialogAction={
        <>
          <StyledButtonV2
            label="Cancel"
            variant="outlined"
            onClick={() => disclosureHost.close()}
          />
          <StyledButtonV2
            label="Save"
            variant="contained"
            onClick={() => {
              draft.save();
              disclosureHost.close();
            }}
            sx={{ width: "105px" }}
          />
        </>
      }
      sx={{
        "& .MuiDialog-paper": {
          width: "50vw",
          height: "75vh",
        },
      }}
    >
      <Flex flexDirection="column" gap={2} pt={2}>
        <Text variant="subtitle1" fontWeight="500">
          Select Risk Level:
        </Text>

        <RadioGroup
          name="riskLevel"
          value={riskLevel}
          onChange={(_, value) => {
            draft.setFieldValue("riskLevel", value);
            draft.setFieldValue("riskLevelNote", "");
          }}
        >
          <Grid container spacing={1}>
            {RISK_LEVEL_OPTIONS.map((option) => (
              <Grid item xs={12} key={option.value}>
                <FormControlLabel
                  value={option.value}
                  control={<Radio />}
                  sx={{ alignItems: "center" }}
                  label={
                    <Text fontSize="14px" fontWeight="500">
                      {option.label}
                    </Text>
                  }
                />
                {riskLevel === option.value && (
                  <Grid item xs={12} sx={{ pl: 4, pt: 1 }}>
                    <CustomTextArea
                      label="Note"
                      name="riskLevelNote"
                      placeholder={option.description || "Type here..."}
                      value={draft.values.riskLevelNote ?? ""}
                      onChange={draft.handleChange}
                      minRows={3}
                    />
                  </Grid>
                )}
              </Grid>
            ))}
          </Grid>
        </RadioGroup>
      </Flex>
    </StyledFormModal>
  );
};

export default RiskAssessmentModal;
